var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGrid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm8 1H6v4h4zM5 1v4H1V2a1 1 0 0 1 1-1zm0 5H1v4h4zm0 5H1v3a1 1 0 0 0 1 1h3zm1 0h4v4H6zm4-1H6V6h4zm1 1v4h3a1 1 0 0 0 1-1v-3zm4-1V6h-4v4zm0-8v3h-4V1h3a1 1 0 0 1 1 1",
  clipRule: "evenodd"
})));
export default SvgGrid;